<template>
  <span v-if="null === orders" class="ui-loader" />
  <div v-else class="my-orders">
    <div v-if="0 !== orders.length" class="my-orders__container">
      <div class="my-orders__title-box">
        <h4 v-for="title in tableTitles" :key="title" class="my-orders__title">
          {{ _T(title) }}
        </h4>
      </div>
      <div class="my-orders__item-list">
        <Order v-for="order in orders" :key="order.id" :order="order" />
      </div>
    </div>
    <div v-else class="my-orders__empty">
      <h4 class="my-orders__empty-title">
        {{ _T("@You have no orders") }} &#128546;
      </h4>
      <img
        src="/img/account-empty-orders.svg"
        alt="empty orders"
        class="my-orders__empty-img"
      />
      <ButtonLink name="catalog">
        {{ _T("@Go to catalog") }}
      </ButtonLink>
    </div>
  </div>
</template>

<script setup>
import Order from "~/modules/account/ui/components/orders/Order.vue";
import ButtonLink from "~/modules/shared/buttons/ButtonLink.vue";

const props = defineProps({
  orders: { type: Array, required: false },
});

const tableTitles = ["@Order number", "@Status", "@Date", "@Sum", "@Product"];
</script>

<style lang="scss" scoped>
.my-orders {
  width: 100%;

  @include flex-container(column, center, center);

  &__container {
    max-width: 1160px;
    width: 100%;
    margin: auto;
  }

  &__title-box {
    display: grid;
    grid-template-columns: 1.5fr 2fr 1fr 1fr 2fr;
    grid-template-rows: 1fr;
    grid-column-gap: 5px;
    grid-row-gap: 0;
    align-items: center;

    margin-bottom: 16px;
    padding: 0 16px;

    @include mobile {
      display: none;
    }
  }

  &__title {
    @include font(16, 22, 400);
    color: var(--color-grey-900);
    text-transform: capitalize;
    text-align: center;

    &:first-of-type {
      text-align: left;
    }
  }

  &__empty {
    width: 100%;

    @include flex-container(column, center, center);
    gap: 16px;
  }

  &__empty-title {
    @include font(24, 30);
    letter-spacing: 0.02em;
    text-align: center;

    @include mobile {
      @include font(18, 24);
    }
  }
}
</style>
